var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'HeaderCards',
        _vm.highlighted && 'HeaderCards--highlighted'
    ]},[_c('div',{staticClass:"HeaderCards__header"},[_vm._v(" "+_vm._s(_vm.header)+" ")]),_c('div',{staticClass:"HeaderCards__number"},[_vm._t("default",[_c('h2',[_vm._v(_vm._s(_vm.number))])])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }